import React, { useContext } from 'react';
import { Drawer, Skeleton, Spin } from 'antd';
import { MainContext } from '../../../contexts/mainContext';
import MyCreateItineraryForm, {
  ItineraryCandidate,
} from './CreateItineraryForm';
import {
  useGetClientRateQuery,
  useServiceTypesQuery,
  useGetVehicleBrandModelsQuery,
  Vat,
  VehicleTypesQuery,
} from '../../../graphql/datamodel.gen';
import { getClient } from '../../../apollo';
import { BudgetConfig } from '../types';

export interface ICreateItineraryProps {
  budgetConfig: BudgetConfig;
  allVehicleTypes: VehicleTypesQuery['vehicleTypes'];
  editing?: boolean;
  itinerary?: ItineraryCandidate;
  visible: boolean;
  onClose: Function;
  onSubmit: (
    itinerary: Partial<Pick<ItineraryCandidate, 'id'>> &
      Omit<ItineraryCandidate, 'id'>,
  ) => any;
  vatTypes: Vat[];
  clientId: string;
}

const CreateItinerary = (props: ICreateItineraryProps) => {
  const { device } = useContext(MainContext);

  const {
    loading: loadingServiceTypes,
    data: dataServiceTypes,
    error: errorServiceTypes,
  } = useServiceTypesQuery({
    client: getClient(),
    fetchPolicy: 'cache-and-network',
  });

  const { data: dataVehicleBrandModels } = useGetVehicleBrandModelsQuery({
    client: getClient(),
    fetchPolicy: 'network-only',
  });

  const { data: rate, loading: loadingRate } = useGetClientRateQuery({
    client: getClient(),
    fetchPolicy: 'network-only',
    variables: {
      clientId: props.clientId,
    },
    skip: !props.clientId,
  });

  const serviceTypes = [...(dataServiceTypes?.serviceTypes || [])];
  const vehicleBrandModels = dataVehicleBrandModels?.vehicleBrandModels || [];

  const loading = loadingServiceTypes || loadingRate;

  let width: string = '50%';

  if (device.type === 'desktop' && device.bigScreen) {
    width = '75%';
  }
  if (device.type === 'desktop' && !device.bigScreen) {
    width = '85%';
  }
  if (device.type === 'phone') {
    if (device.bigScreen) {
      width = '85%';
    } else {
      width = '100%';
    }
  }

  return (
    <Drawer
      title={props.itinerary ? 'Editar itinerario' : 'Crear nuevo itinerario'}
      width={width}
      visible={props.visible}
      destroyOnClose={true}
      closable={true}
      maskClosable={false}
      onClose={() => props.onClose()}
    >
      {loading && <Skeleton active={true} loading={true} />}
      {!loading && (
        <MyCreateItineraryForm
          clientId={props.clientId}
          allVehicleBrandModels={vehicleBrandModels}
          allVehicleTypes={props.allVehicleTypes}
          budgetConfig={props.budgetConfig}
          vatTypes={props.vatTypes}
          close={() => props.onClose()}
          itinerary={props.itinerary}
          serviceTypes={serviceTypes}
          rate={rate?.client?.rate}
          onSubmit={props.onSubmit}
        />
      )}
    </Drawer>
  );
};

export default CreateItinerary;
